
import React, { useState, useEffect } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronUp, Filter, RotateCcw, User } from 'feather-icons-react/build/IconComponents';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
// import AddPurchases from '../../core/modals/purchases/addpurchases';
// import EditPurchases from '../../core/modals/purchases/editpurchases';
// import ReceivePOStock from '../../core/modals/purchases/receivestock';
import Axios from 'axios';
import { API_BASE_URL, GET_INVOICES } from '../../Config';
import ViewInvoice from './../../core/modals/purchases/viewinvoice';
import Table from '../../core/pagination/datatable';
// import NewPOInvoice from '../../core/modals/purchases/newpurchaseinvoice';
import GenerateInvoicePayment from '../../core/modals/purchases/invoicepayment';
import InvoicePaymentView from '../../core/modals/purchases/invoicepaymentview';
import UploadFiles from '../UploadFiles';
import SpinLoader from "../loader/SpinLoader";


const InvoiceList = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    // const [editPOData, setEditPOData] = useState('');
    // const [receiveStockData, setReceiveStockData] = useState('');
    const navigate = useNavigate();

    // #region Session userdetails
    useEffect(() => {
      const userDataString = sessionStorage.getItem("userData");
      const supplierDataddl = JSON.parse(sessionStorage.getItem('filteredDDLData_Supplier'));
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserDataSession(userData);
        setSuppliersData(supplierDataddl);
      } else {
          console.log("User data not found in sessionStorage");
          navigate('/');
      }
    }, []);

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);

    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [suppliersData, setSuppliersData] = useState([]);
    const [invoiceData, setInvoiceData] = useState([]);
    const [loading, setLoading] = useState(false);  

    // const [selectedStatus, setSelectedStatus] = useState(null);
    // const [selectedPONo, setSelectedPONo] = useState('');
    // const [selectedSupplier, setSelectedSupplier] = useState(null);
    // const [selectedFromDate, setSelectedFromDate] = useState('');
    // const [selectedToDate, setSelectedToDate] = useState('');
    const [viewInvoiceObj, setViewInvoiceObj] = useState([]); 
    const [uploadInvoiceObj, setUploadInvoiceObj] = useState([]); 
    const [paymentInvoiceData, setPaymentInvoiceObj] = useState([]); 
    const [paymentInvoiceViewData, setPaymentInvoiceViewObj] = useState([]); 

    const showViewModal = (purchaseObj) => {
        setViewInvoiceObj(purchaseObj);
    };

    const showUploadFilesModal = (purchaseObj) => {
        setUploadInvoiceObj(purchaseObj);
    };

    const showPaymentModal = (purchaseObj) => {
        setPaymentInvoiceObj(purchaseObj);
    };

    const showPaymentViewModal = (purchaseObj) => {
        setPaymentInvoiceViewObj(purchaseObj);
    };

    const toggleFilterVisibility = () => {
        setIsFilterVisible((prevVisibility) => !prevVisibility);
    };

    useEffect(() => {

        if (userDataSession && userDataSession.OrgId){
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_INVOICES}?OrgId=${userDataSession.OrgId}`)
                .then(response => {
                    if (response.data.Status) {
                        
                        setInvoiceData(response.data.ResultData);
                        console.log(response.data.ResultData, 'get invoice data');
                        setLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    
    }, [userDataSession]);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Printer
        </Tooltip>
    );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    // const handleEditClick = (item) => {
    //     setEditPOData(item);
    // };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Define a function to get the class name based on the status value
    const getStatusClassName = (status) => {
        const normalizedStatus = status.toLowerCase();
        switch (normalizedStatus) {
            case 'paid':
                return 'badge bg-outline-success';
            case 'partiallypaid':
                return 'badge bg-outline-info';
            case 'pending':
                return 'badge bg-outline-warning';
            default:
                return '';
        }
    };    

    const [searchValue, setSearchValue] = useState('');
    const [filteredData, setFilteredData] = useState(invoiceData);

    useEffect(() => {
        setFilteredData(invoiceData);
    }, [invoiceData]);

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearchValue(value);
        filterData(value);
    };

    const filterData = (searchText) => {
        const lowercasedSearchText = searchText.toLowerCase();
    
        const filtered = invoiceData?.filter(item => {
            // Convert AutoGenTransactionNo to string and then to lowercase for comparison
            const transactionNo = item.AutoGenTransactionNo ? item.AutoGenTransactionNo.toString().toLowerCase() : '';
            const supplierName = item.SupplierName ? item.SupplierName.toLowerCase() : '';
            const invocieStatus = item.InvocieStatus ? item.InvocieStatus.toLowerCase() : '';
    
            return (
                transactionNo.includes(lowercasedSearchText) ||
                supplierName.includes(lowercasedSearchText) ||
                invocieStatus.includes(lowercasedSearchText)
            );
        });
        setFilteredData(filtered);
    };
    

    const columns = [
        {
            title: 'Number',
            dataIndex: 'AutoGenTransactionNo',
            key: 'AutoGenTransactionNo',
            render: (text) => `${text}`,
        },
        {
            title: 'Date',
            dataIndex: 'InvoiceDate',
            key: 'InvoiceDate',
            render: (text) => formatDate(text),
        },
        {
            title: 'Supplier',
            dataIndex: 'SupplierName',
            key: 'SupplierName',
            render: (text) => `${text}`,
        },
        {
            title: 'Amount',
            dataIndex: 'InvoiceAmount',
            key: 'InvoiceAmount',
            render: (value) => value != null ? value : 0
        },
        {
            title: 'Paid Amount',
            dataIndex: 'PaidAmount',
            key: 'PaidAmount',
            render: (value) => value != null ? value : 0
        },          
        {
            title: 'Status',
            dataIndex: 'InvoiceStatus',
            key: 'InvoiceStatus',
            render: (status) => (
                <span className={getStatusClassName(status)}>
                    {status}
                </span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <div>
                    <Link
                            to="#"
                            className="dropdown-toggl"
                            data-bs-toggle="dropdown"
                        >
                            <i className="fa-solid fa-ellipsis-vertical btn border"></i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                        <Link to="#" className="dropdown-item"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightInvView"
                            aria-controls="offcanvasRightInfView"
                            onClick={() => showViewModal(record)}
                        >
                            <i className="fa-regular fa-eye me-2"></i>
                            View
                        </Link>
                        <Link 
                            to="#" 
                            className={`dropdown-item ${record.InvoiceStatus?.toLowerCase() === 'paid' ? 'disabled' : ''}`}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightInvPayment"
                            aria-controls="offcanvasRightInvPayment"
                            onClick={() => showPaymentModal(record)}
                        >
                            <i className="fa-solid fa-hand-holding-dollar me-2"></i>Payment
                        </Link>
                        <Link 
                            to="#" 
                            className={`dropdown-item`}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightInvViewPay"
                            aria-controls="offcanvasRightInvViewPay"
                            onClick={() => showPaymentViewModal(record)}
                        >
                            <i className="fa-solid fa-coins me-2"></i>View Payment
                        </Link>
                        <Link 
                            to="#" 
                            className={`dropdown-item`}
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightUploadFiles"
                            aria-controls="offcanvasRightUploadFiles"
                            onClick={() => showUploadFilesModal(record)}
                        >
                            <i className="fa-solid fa-cloud-arrow-up me-2"></i>Upload Files
                        </Link>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header transfer">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Invoices List</h4>
                                <h6>Manage your invoices</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        {/* <div className="d-flex purchase-pg-btn">
                            <div className="page-btn">
                                <Link
                                    to="#"
                                    className="btn btn-added"
                                    data-bs-toggle="modal"
                                    data-bs-target="#new-purchase-invoice"
                                >
                                    <PlusCircle className="me-2"/> 
                                    Genearte New Invoice
                                </Link>
                            </div>
                        </div> */}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        value={searchValue}
                                        onChange={handleSearchChange}
                                        className="form-control form-control-sm formsearch"
                                    />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="search-path">
                                    <Link className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} id="filter_search">
                                        <Filter
                                            className="filter-icon"
                                            onClick={toggleFilterVisibility}
                                        />
                                        <span onClick={toggleFilterVisibility}>
                                            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                                        </span>
                                    </Link>
                                </div>
                                {/* <div className="form-sort">
                                    <Sliders className="info-img" />
                                    <Select
                                        className="select"
                                        options={oldandlatestvalue}
                                        placeholder="Newest"
                                    />
                                </div> */}
                            </div>
                            {/* /Filter */}
                            <div
                                className={`card${isFilterVisible ? " visible" : ""}`}
                                id="filter_inputs"
                                style={{ display: isFilterVisible ? "block" : "none" }}
                            >
                                <div className="card-body pb-0">
                                    <div className="row">
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label>PO Number</label>
                                            <div className="input-blocks">
                                                <User className="info-img"/>
                                                <input
                                                    type="text"
                                                    className="select"
                                                    placeholder="PO Number"
                                                    // onChange={(e) => {setSelectedPONo(e.target.value)}}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label>Supplier</label>
                                            <div className="input-blocs">
                                                {/* <User className="info-img"/> */}
                                                <Select
                                                    className="select"
                                                    id="categorySelect"
                                                    // value={selectedSupplier}
                                                    // onChange={handleSupplierChange}
                                                    options={suppliersData?.map(store => ({
                                                        value: store.ItemId,
                                                        label: store.ItemValue 
                                                    }))}
                                                    placeholder="Choose supplier"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label>From Date</label>
                                            <div className="input-blocs">
                                                <input 
                                                    type='date'
                                                    className='form-control'
                                                    // onChange={handleFromDateChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label>To Date</label>
                                            <div className="input-bloks">
                                                <input 
                                                    type='date'
                                                    className='form-control'
                                                    // onChange={handleToDateChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="input-bloks" style={{ marginTop: '-4.5rem' }}>
                                                <button 
                                                    className="btn btn-filters ms-auto"
                                                    // onClick={handleSearchClick}
                                                >
                                                    {" "}
                                                    <i data-feather="search" className="feather-search" />{" "}
                                                    Search{" "}
                                                </button>
                                            </div>
                                        {/* <div className=" ms-auto">
                                            <div className="input-blocks">
                                                <button 
                                                    className="btn btn-filters ms-auto"
                                                    onClick={handleSearchClick}
                                                >
                                                    {" "}
                                                    <i data-feather="search" className="feather-search" />{" "}
                                                    Search{" "}
                                                </button>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            {/* /Filter */}

                            {/* <Table
                                columns={columns}
                                dataSource={filteredData}
                                pagination={{ pageSize: 10 }}
                                rowKey="AutoGenTransactionNo"
                            /> */}
                            <div className="table-responsive">
                                {loading ? (
                                    <SpinLoader/>
                                    // <div className="loader m-auto"></div>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} rowKey="PurchaseId" pagination={{ pageSize: 10 }} />
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>

            <ViewInvoice INVObj={viewInvoiceObj} />
            <GenerateInvoicePayment INVObj={paymentInvoiceData} />
            <InvoicePaymentView INVObj={paymentInvoiceViewData} />
            <UploadFiles number={uploadInvoiceObj.PurchaseId} type={"Purchase"} />

            {/* <EditPurchases POObj={editPOData} /> */}
            {/* <NewPOInvoice /> */}
        </div>
    )
}

export default InvoiceList;
